import React from 'react';
import Styled from 'styled';
import { Link } from 'react-router-dom';

import SVGIconView from 'lib/images/svg-icon-view';
import ImageView from 'lib/images/image-view';

import IconCamera from 'four-nets/icons/svg/icon_photo.svg';
import IconLike from 'four-nets/icons/svg/icon_like-2.svg';

import { AuthorAlbumFragment } from './author-album.graphql';
import defaultStyles from './author-album.scss';
import TextShortener from 'four-nets/ui-v2/text-shortener/text-shortener';

export interface Props extends AuthorAlbumFragment {
    styles: typeof defaultStyles;
}

class AuthorAlbum extends React.PureComponent<Props> {
    render() {
        const { styles, node } = this.props;

        if (!node || !node.user) {
            return null;
        }

        const { user, slug, images, title, imagesCount, likesCount } = node;
        const username = user.username;

        const postLink = user.profile!.isVendor
            ? `/catalog/vendor/${username}/blog-album/${slug}/`
            : `/blog/${username}/album/${slug}/`;

        const photoFile =
            images &&
            images.edges &&
            images.edges.length >= 1 &&
            images.edges[0]!.node &&
            images.edges[0]!.node.photoFile;

        return (
            <div className={styles.wrapper}>
                <div className={styles.image}>
                    {photoFile && photoFile.srcset ? (
                        <ImageView
                            aspectFill={true}
                            srcSet={photoFile.srcset}
                            src={photoFile.src}
                            sizes={{ xs: 160 }}
                        />
                    ) : null}
                </div>
                <div className={styles.info}>
                    <Link to={postLink} className={styles.link}>
                        <p className={styles.title}>
                            <TextShortener text={title} textLength={72} />
                        </p>
                    </Link>
                    <div className={styles.stats}>
                        <div className={styles.stat}>
                            <SVGIconView className={styles.iconCamera} src={IconCamera} />
                            <span className={styles.statText}>{imagesCount}</span>
                        </div>
                        {likesCount && likesCount > 0 ? (
                            <div className={styles.stat}>
                                <SVGIconView className={styles.iconLikes} src={IconLike} />
                                <span className={styles.statText}>{likesCount}</span>
                            </div>
                        ) : null}
                    </div>
                </div>
            </div>
        );
    }
}

export default Styled(defaultStyles)(AuthorAlbum);
